import * as LodashFP from 'lodash/fp'
import { resultError, resultSuccess } from '../../interfaces/base'
import {
  DeleteFile,
  GetExcelForCreativeId,
  GetFileDownloadUrl,
  GetDownloadFormatsetZipUrl,
  GetFileInfo,
  GetFileUrl,
  IFilesService,
  UploadFile,
} from '../../interfaces/services/files'
import { apiUrl } from '../../utils/api'
import { appErrorFromAnything } from '../../utils/error'
import { decode, doHttp } from '../../utils/json-api'
import adapters from './adapters'

const filesService: (DI: any) => IFilesService = (DI) => {
  const getFile = async (url: string) => {
    return url
  }

  const getFileInfo: GetFileInfo = async (id) => {
    try {
      const response = await doHttp(
        {
          method: 'get',
          url: `/api/creatives/files/${id}/info`,
        },
        {
          throwOnError: true,
          expectedErrorCodes: [404],
        },
      )
      const decoded = decode(adapters.file, response)
      return resultSuccess(decoded)
    } catch (e) {
      return resultError(e)
    }
  }

  const uploadFile: UploadFile = async (file, creativeId) => {
    try {
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
        },
      }
      const data = new FormData()
      data.append('asset', file)

      const response = await doHttp(
        {
          method: 'post',
          url: `/api/creatives/${creativeId}/files`,
          data,
          config,
        },
        {
          expectedErrorCodes: [422, 500],
        },
      )

      const status = LodashFP.getOr(201, ['statusCode'], response)
      const errors = LodashFP.getOr([], ['data', 'errors'], response)
      if ([422, 500].includes(status) || errors.length > 0) {
        const message =
          errors.length > 0 ? errors.join(', ') : response.data.message
        return resultError(appErrorFromAnything(message))
      }

      const decoded = decode(adapters.file, response)
      return resultSuccess(decoded)
    } catch (e) {
      return resultError(appErrorFromAnything(e))
    }
  }

  const getFileUrl: GetFileUrl = (fileId, publicRoute) => {
    const url = !publicRoute
      ? `/api/creatives/files/${fileId}`
      : `/api/public/creatives/files/${fileId}`
    return apiUrl(url)
  }

  const getFileThumbnailUrl: GetFileUrl = (fileId) => {
    return apiUrl(`/api/creatives/files/${fileId}/thumbnail`)
  }

  const getFileDownloadUrl: GetFileDownloadUrl = (
    fileId,
    creativeId,
    slideOrder,
  ) => {
    if (slideOrder) {
      // Add slideOrder to URL
      return apiUrl(
        `/api/creatives/${creativeId}/files/${fileId}/download?index=${slideOrder}`,
      )
    } else {
      return apiUrl(`/api/creatives/${creativeId}/files/${fileId}/download`)
    }
  }

  const getExcel: GetExcelForCreativeId = (creativeId) => {
    return apiUrl(`/api/creatives/${creativeId}/excel`)
  }

  const deleteFile: DeleteFile = async (id) => {
    try {
      const response = await doHttp(
        {
          method: 'delete',
          url: `/api/creatives/files/${id}`,
        },
        {
          throwOnError: true,
          expectedErrorCodes: [404],
        },
      )
      return response
    } catch (e) {
      return false
    }
  }

  const getDownloadFormatsetZipUrl: GetDownloadFormatsetZipUrl = (
    formatsetId,
  ) => {
    return apiUrl(`/api/formatsets/${formatsetId}/download`)
  }

  return {
    getFileUrl,
    getFileThumbnailUrl,
    getFileDownloadUrl,
    getExcel,

    getFile,
    getFileInfo,

    uploadFile,

    deleteFile,
    getDownloadFormatsetZipUrl,
  }
}

export default filesService
